import Dbm from "dbm";
import Website from "../../index.js";

//import * as PIXI from "pixi.js";
//import Matter from "matter-js";

export default class StartScreen extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let keyboardInput = new Website.game.screens.KeyboardInput();
        keyboardInput.item.screen = this.item;
        this.item.requireProperty("keyboardInput", keyboardInput.item);

        this.item.requireProperty("game", null);

        let layer = new PIXI.Container()
        this.item.requireProperty("pixiLayer", layer);

        let background = Dbm.flow.externalObject(new PIXI.Container());
        background.addProperty("alpha", 1);

        layer.addChild(background.object);
        this.item.setValue("background", background.item);

        let startButton = Dbm.flow.externalObject(new PIXI.Container());
        startButton.addProperty("alpha", 0);

        startButton.object.eventMode = "static";
        startButton.object.on("pointerdown", this._callback_startClicked.bind(this));
        layer.addChild(startButton.object);
        this.item.setValue("startButton", startButton.item);

        let textLinesLayer = Dbm.flow.externalObject(new PIXI.Container());
        textLinesLayer.object.position.x = 10;
        textLinesLayer.addProperty("y", 0, "position.y");
        layer.addChild(textLinesLayer.object);
        this.item.setValue("textLinesLayer", textLinesLayer.item);

        let logo = Dbm.flow.externalObject(new PIXI.Container());
        logo.addProperty("alpha", 1);
        logo.addProperty("scale", 1);
        logo.addProperty("y", 0, "position.y");

        layer.addChild(logo.object);
        this.item.setValue("logo", logo.item);
    }

    _callback_startClicked(aEvent) {
        //console.log("_callback_startClicked");
        //console.log(aEvent.pointerType);

        if(aEvent.pointerType === "touch" && Dbm.repository.getItem("site").gameMode !== "arcade") {
            this.item.game.inputMode = "touch";
        }
        else {
            this.item.game.inputMode = "keyboard";
        }

        this._continue();
    }

    _continue() {
        if(Dbm.repository.getItem("site").developmentMode) {
            this.item.game.playerId = "saga";
            this.item.game.gamePlay.controller.setupLevel();
            this.item.game.gamePlay.controller.setupCharacter();
            this.item.game.gamePlay.controller.reset();

            //this.item.game.controller.changeScreen("gamePlay");
            this.item.game.controller.changeScreen("gameOver"); //MEDEBUG

            //this.item.game.controller.startSession(); //MEDEBUG
            //this.item.game.controller.changeScreen("howToPlay"); //MEDEBUG
        }
        else {
            this.item.game.controller.startSession();
            this.item.game.controller.changeScreen("selectCharacter");

            let sound = Website.game.getTextures("sounds/interface", "start")[0];
            sound.play({loop: false, volume: 0.5});


            window.dataLayer = window.dataLayer || []
            dataLayer.push({
                'event': 'tillvaxtspeletStart',
            });
        }

        this.item.game.controller.scrollIntoView();
    }

    prepare() {
        //console.log("prepare");

        let backgroundSprite = Website.game.getSprite("screens/background", "main");
        backgroundSprite.anchor.set(0, 0);
        this.item.background.object.addChild(backgroundSprite);

        let texture = Website.game.getTextures("screens/start", "logo")[0];

        let logoWidthOfScreen = 0.8;
        let scale = logoWidthOfScreen*Website.game.Sizes.WIDTH/texture.width;

        let margin = 0.5*(Website.game.Sizes.WIDTH-(scale*texture.width));
        let logoHeight = (scale*texture.height);

        let sprite = new PIXI.Sprite(texture);
        sprite.anchor.set(0.5, 0);
        this.item.logo.object.scale = scale;
        this.item.logo.scale = scale;
        this.item.logo.object.position.x = Website.game.Sizes.CENTER_X;
        this.item.logo.object.position.y = margin;
        this.item.logo.y = margin;
        this.item.logo.object.addChild(sprite);
        
        let buttonHeight = 20;
        let buttonWidth = 80;

        const box = Website.game.getButton();
        box.width = buttonWidth;
        box.height = buttonHeight;
        this.item.startButton.object.addChild(box);

        this.item.startButton.object.x = 0.5*(Website.game.Sizes.WIDTH-buttonWidth);
        this.item.startButton.object.y = Website.game.Sizes.HEIGHT-buttonHeight-20;

        this.item.textLinesLayer.y = margin+logoHeight+10;
        
        let text = Dbm.getRepositoryItem("game").controller.getText("STARTA");
        
        text.position.x = 0.5*(buttonWidth-text.width);
        text.position.y = 0.5*(buttonHeight-text.height);

        this.item.startButton.object.addChild(text);

        let textLines = [
            "Sverige behöver fortsätta utvecklas.",
            "Vi behöver mer investeringar, nya uppfinningar, bättre utbildningar och större intäkter.",
            "I över 160 år har svenska företag och svensk företagsamhet gett oss en rikare tillvaro.",
            "Men för att det ska fortsätta behöver vi ge dem rätt förutsättningar.",
            "Nu behöver vi din hjälp att låsa upp vår tillväxt.",
            "Hjälp oss besegra krångliga regelverk, höga skatter och avgifter, långsam byråkrati och visionslös politik.",
            "Låt oss ta Sverige till nästa nivå."
        ];

        let controllers = [];

        let currentY = 0;
        let currentArray = textLines;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            let currentText = currentArray[i];

            let currentController = Dbm.flow.externalObject(new PIXI.Container());
            controllers.push(currentController.item);
            currentController.addProperty("alpha", 0);
            currentController.object.alpha = 0;

            this.item.textLinesLayer.object.addChild(currentController.object);
            currentController.object.position.y = currentY;
            currentController.item.setValue("y", currentY);

            let textLayer = Dbm.getRepositoryItem("game").controller.getText(currentText, 16, '#FFFFFF', {align: "center", wordWrap: true, wordWrapWidth: Website.game.Sizes.WIDTH-2*10, lineHeight: 18});
            textLayer.position.x = Math.round(0.5*(Website.game.Sizes.WIDTH-2*10-textLayer.width));
            currentController.object.addChild(textLayer);

            currentY += textLayer.height + 5;
        }

        this.item.textLinesLayer.setValue("textHeight", currentY-5);

        this.item.setValue("textLines", controllers);
    }

    start() {

        this.item.keyboardInput.active = true;

        let texture = Website.game.getTextures("screens/start", "logo")[0];

        let logoWidthOfScreen = 0.8;
        let scale = logoWidthOfScreen*Website.game.Sizes.WIDTH/texture.width;

        let margin = 0.5*(Website.game.Sizes.WIDTH-(scale*texture.width));
        let logoHeight = (scale*texture.height);

        let textAnimationTime = 10;

        if(Dbm.repository.getItem("site").developmentMode) {
            textAnimationTime = 1;
        }

        //this.item.logo.alpha = 0;
        this.item.logo.properties.y.animateValue(5, 0.6*textAnimationTime, 0.4);
        this.item.logo.properties.scale.animateValue(0.5*scale, 0.6*textAnimationTime, 0.4);

        this.item.startButton.alpha = 0;
        this.item.startButton.properties.alpha.animateValue(1, 0.3, textAnimationTime);

        

        let textHeight = this.item.textLinesLayer.textHeight;

        let currentArray = this.item.textLines;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            let currentLine = currentArray[i];
            let currentY = currentLine.object.y;
            currentLine.properties.alpha.animateValue(1, 2, textAnimationTime*(currentY/textHeight));

            if(i < 4) {
                currentLine.properties.alpha.addAddionalAnimation(1, 0, 2.2, 4+textAnimationTime*(currentY/textHeight));
            }
        }

        this.item.textLinesLayer.properties.y.animateValue(this.item.textLinesLayer.y-this.item.textLinesLayer.textHeight, textAnimationTime, 0.4, (value) => {return value;});
    }

    update(aTime, aDelta) {
        
    }

    stop() {
        //console.log("stop");
        this.item.keyboardInput.active = false;
    }

    rightInput() {
        this._continue();
    }
}